import { DictionaryKeyDelimiter, QuestionType, SelectionType } from '../bom/constants';

import { NumericValueOfNotAvailable } from '../utils/constants';

export const getLowestSellUnitPriceForUpsellItem = (price, quantity) => {
  if (!price || !price.priceTable || price.priceTable.length === 0) return NumericValueOfNotAvailable;
  const hasNavInkDiscount = price.hasNavInkDiscount;
  const isClearance = price.isClearance;
  const isEveryDayLowPrice = price.isEveryDayLowPrice;
  const isOnSale = price.isCouponApplied && !!price.coupon && price.coupon.isItemLevel && price.freeQuantityRatio === 0;
  const rows = price.priceTable.filter((row) => row.quantity <= quantity);
  const targetRow = rows.length > 0 ? rows[rows.length - 1] : price.priceTable[0];
  return hasNavInkDiscount || isClearance || isEveryDayLowPrice || isOnSale
    ? targetRow.discountedUnitPrice
    : targetRow.unitPrice;
};

export const getFinalBomOptionsSelectionForUpsellItem = (upsell) => {
  const bomOptions = [];
  const pseudoParentChildQuestionOptionDictionaryList = [];
  const { questions, relations, uniqueOptions, childOptions, totalQuantity: quantity } = upsell;

  questions.forEach((question) => {
    let code;
    let selectedOption;
    if (question.questionType === QuestionType.GENERAL) {
      code = question.code;
      if (Object.keys(uniqueOptions).includes(code)) {
        selectedOption = uniqueOptions[code].find((option) => option.isSelected);
        if (selectedOption) {
          bomOptions.push({
            componentId: selectedOption.componentId,
            quantity: question.selectionType === SelectionType.MULTIPLE ? quantity : 0,
          });
        }
      }
    } else if (question.questionType === QuestionType.ROOT) {
      let tmpOptions;
      let tmpQuestion = question;
      const keyParts = [];
      const tmpQuestions = [question];
      while (tmpQuestion && tmpQuestion.questionType !== QuestionType.LEAF) {
        code = tmpQuestion.code;
        tmpOptions = Object.keys(uniqueOptions).includes(code) ? uniqueOptions[code] : [];
        selectedOption = tmpOptions.find((option) => option.isSelected);
        if (selectedOption) {
          keyParts.push(question.isRealParentChildQuestion ? selectedOption.codeValue : selectedOption.componentId);
        }

        const childCode = Object.keys(relations).includes(code) ? relations[code] : '';
        tmpQuestion = questions.find((question) => question.code === childCode);
        if (tmpQuestion) tmpQuestions.push(tmpQuestion);
      }

      const leafCode = tmpQuestion.code;
      const leafOptionDict = Object.keys(childOptions).includes(leafCode) ? childOptions[leafCode] : {};
      const leafKey =
        keyParts.length === 0 ? '' : keyParts.reduce((key, keyPart) => key.concat(DictionaryKeyDelimiter, keyPart));
      const hasMultipleSelectionQuestion = tmpQuestions.some(
        (question) => question.selectionType === SelectionType.MULTIPLE
      );

      tmpOptions = Object.keys(leafOptionDict).includes(leafKey) ? leafOptionDict[leafKey] : [];
      selectedOption = tmpOptions.find((option) => option.isSelected);
      if (selectedOption) {
        const newOption = {
          componentId: selectedOption.componentId,
          quantity: hasMultipleSelectionQuestion ? quantity : 0,
        };
        if (question.isRealParentChildQuestion) {
          bomOptions.push(newOption);
        } else {
          pseudoParentChildQuestionOptionDictionaryList.push({ [leafKey]: [newOption] });
        }
      }
    }
  });

  const finalSelection = { bomOptions, pseudoParentChildQuestionOptionDictionaryList, quantity };
  console.log('Final BomOptions Selection For Upsell Item:');
  console.log(finalSelection);
  return finalSelection;
};
